/**
 * Single source of truth for external entity type string values.
 * Used by comments (CommentEntityType), analytics, ERP sync, and event routing.
 * Add new external entity types here only.
 */
enum ExternalEntityTypeEnum {
    ExternalInvoice = 'external-invoice',
    ExternalBuyer = 'external-buyer',
    ExternalPayment = 'external-payment',
    ExternalItem = 'external-item',
    ExternalExpense = 'external-expense',
}

/**
 * Type representing a valid external entity type (string literal union).
 */
type ExternalEntityType = `${ExternalEntityTypeEnum}`;

/**
 * List of all external entity types, derived from ExternalEntityTypeEnum.
 * Used only internally to build EXTERNAL_ENTITY_TYPES_SET for isExternalEntityType().
 */
const EXTERNAL_ENTITY_TYPES: readonly ExternalEntityType[] = Object.values(ExternalEntityTypeEnum) as ExternalEntityType[];

/**
 * Set of external entity types for efficient lookup.
 */
const EXTERNAL_ENTITY_TYPES_SET = new Set<string>(EXTERNAL_ENTITY_TYPES);

/**
 * Helper function to check if a given entity type is an external entity type.
 * @param entityType - The entity type to check
 * @returns True if the entity type is an external entity type, false otherwise
 */
export function isExternalEntityType(entityType: string): entityType is ExternalEntityType {
    return EXTERNAL_ENTITY_TYPES_SET.has(entityType);
}
